import { Component, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { workflowBuildingBlockRegistry } from '../../shared/workflow-registries';
import { CoreBuildingBlockControlBaseComponent } from '../shared/building-block-control-base.component';
import { BuildingBlockElementsBaseComponent } from '../shared/building-block-elements-base.component';

/**
 * The component responsible to resolve and render the building block
 */
@Component({
  selector: 'cu-building-block-resolver',
  templateUrl: './building-block-resolver.component.html',
  standalone: false
})
export class BuildingBlockResolverComponent extends BuildingBlockElementsBaseComponent implements OnInit {
  /**
   * Reference to  controlContainer where building block is rendered
   */
  @ViewChild('controlContainer', { static: true, read: ViewContainerRef })
  public controlContainer: ViewContainerRef;

  constructor(private readonly componentFactoryResolver: ComponentFactoryResolver) {
    super();
  }

  public ngOnInit(): void {
    // generate and set control instance properties
    const controlInstance = workflowBuildingBlockRegistry[this.field.config.type];
    if (!controlInstance) {
      throw new Error(`No building block has been registered for type '${this.field.config.type}' in field id '${this.field.id}'. `);
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(controlInstance);
    const component = this.controlContainer.createComponent(factory) as ComponentRef<CoreBuildingBlockControlBaseComponent>;
    component.instance.page = this.page;
    component.instance.card = this.card;
    component.instance.field = this.field;
    component.instance.pageSubmitted$ = this.pageSubmitted$;
  }
}
